import React, { useEffect, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { CustomCheckbox } from '../common/checkbox';
import { SubmitButton } from '../services/pipeline/Form/Common/SubmitButton';
import { EmailRegex, ENDPOINTS } from '../../helpers/constants';

export const AddPublicOrderDetails = ({ defaultValues, handleFinalSubmit, handleBack, status }) => {
  const [formData, setFormData] = useState({
    requestingPersonName: '',
    requestingPersonEmail: '',
    requestingPersonPhone: '',
    organizationName: '',
    hasWorkedWithUsBefore: false
  });
  const [errors, setErrors] = useState({
    requestingPersonName: '',
    requestingPersonEmail: '',
    organizationName: '',
    requestingPersonPhone: ''
  });
  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      requestingPersonName: '',
      requestingPersonEmail: '',
      organizationName: '',
      requestingPersonPhone: ''
    };

    if (!formData.requestingPersonName) {
      newErrors.requestingPersonName = 'Name is required';
      isValid = false;
    }
    if (!formData.organizationName) {
      newErrors.organizationName = 'Organization Name is required';
      isValid = false;
    }
    if (!formData.requestingPersonEmail) {
      newErrors.requestingPersonEmail = 'Email is required';
    } else if (!EmailRegex.test(formData.requestingPersonEmail)) {
      newErrors.requestingPersonEmail = 'Please enter a valid email';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    const isValid = validateForm();
    if (!isValid) return;
    handleFinalSubmit(ENDPOINTS.PUBLIC_CREATE_SERVICES, formData);
  };

  useEffect(() => {
    setFormData(prevData => ({ ...prevData, ...defaultValues }));
  }, [defaultValues]);

  return (
    <div className="lein-search-container relative">
      <p className="order-type-section-title mb-1">Complete Your Order</p>
      <p className="order-type-section-subtitle">Just a few more details to finalize your request!</p>
      <Col md={12} className="p-0">
        <p className="col-title my-2">Contact Information</p>
      </Col>
      <Row>
        <Col className="align-self-end" md={6} xs={12}>
          <Form.Group className="midFont">
            <Form.Label htmlFor="requestingPersonName" className="font-weight-medium">
              Full Name <span className="text-danger">*</span>
            </Form.Label>
            <input
              placeholder="Enter your Name"
              id="requestingPersonName"
              name="requestingPersonName"
              onChange={handleChange}
              type="text"
              value={formData['requestingPersonName'] || ''}
              className={`form-control form-control-sm ${errors['requestingPersonName'] !== '' && 'input-invalid'}`}
            />
            {errors['requestingPersonName'] !== '' && <p className="xsmallFont text-rush">This is a required Field</p>}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="midFont">
            <Form.Label htmlFor="requestingPersonEmail" className="font-weight-medium">
              Email <span className="text-danger">*</span>
            </Form.Label>
            <input
              placeholder="Enter your email"
              name="requestingPersonEmail"
              id="requestingPersonEmail"
              onChange={handleChange}
              type="email"
              value={formData['requestingPersonEmail'] || ''}
              className={`form-control form-control-sm ${errors['requestingPersonEmail'] !== '' && 'input-invalid'}`}
            />
            {errors['requestingPersonEmail'] !== '' && <p className="xsmallFont text-rush">Not a valid Email</p>}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="midFont">
            <Form.Label htmlFor="requestingPersonPhone" className="font-weight-medium">
              Phone Number
            </Form.Label>
            <input
              name="requestingPersonPhone"
              placeholder="Enter your phone number"
              id="requestingPersonPhone"
              onChange={handleChange}
              type="text"
              value={formData['requestingPersonPhone'] || ''}
              className={`form-control form-control-sm ${errors['requestingPersonPhone'] !== '' && 'input-invalid'}`}
            />
            {errors['requestingPersonPhone'] !== '' && <p className="xsmallFont text-rush">This is a required Field</p>}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="midFont">
            <Form.Label htmlFor="organizationName" className="font-weight-medium">
              Organization Name <span className="text-danger">*</span>
            </Form.Label>
            <input
              name="organizationName"
              placeholder="Enter your organization name"
              id="organizationName"
              onChange={handleChange}
              type="text"
              value={formData['organizationName'] || ''}
              className={`form-control form-control-sm ${errors['organizationName'] !== '' && 'input-invalid'}`}
            />
            {errors['organizationName'] !== '' && <p className="xsmallFont text-rush">This is a required Field</p>}
          </Form.Group>
        </Col>
      </Row>
      <div className="mb-4">
        <CustomCheckbox
          id="hasWorkedWithUsBefore"
          name="hasWorkedWithUsBefore"
          checked={formData['hasWorkedWithUsBefore']}
          onChange={handleChange}
        >
          <Form.Label htmlFor="hasWorkedWithUsBefore" className="font-weight-medium ml-1 mb-0">
            I have worked with Accurate before
          </Form.Label>
        </CustomCheckbox>
      </div>
      <div className="empty-section" />
      <SubmitButton onCancel={handleBack} onSubmit={handleSubmit} status={status} buttonText={'Submit'} />
    </div>
  );
};
